import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import SiteHeader from "@/components/blocks/SiteHeader.vue";
import tagluffaieuropa_logo from "./assets/SVG/tagluffaieuropa_logo.vue";
import { useTrackingStore } from "./store/trackingStore";
import SiteFooter from "@/components/blocks/SiteFooter.vue";
import CustomModal from "@/components/generics/CustomModal.vue";
import { onMounted, reactive, watch } from "vue";
import { useRoute } from "vue-router";
import CustomButton from "./components/generics/CustomButton.vue";
import CookieModal from "./components/blocks/CookieModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const trackingStore = useTrackingStore();
const route = useRoute();

const hide_footer_on = [
  "/biljetter/biljettval",
  "/biljetter/resenarer",
  "/biljetter/summary",
];

const state = reactive({
  showFooter: true,
  showCookieModal: false,
});
trackingStore.userId = trackingStore.getCookiesAccept().userId;

onMounted(() => {
  if (trackingStore.userId != "") {
    var cookies = trackingStore.getCookiesAccept();
    trackingStore.initializeTracking("consent", "default", {
      ad_storage: cookies.adAcceptCookie ? "granted" : "denied",
      analytics_storage: cookies.analyticsCookie ? "granted" : "denied",
    });
  } else {
    state.showCookieModal = true;
  }

  console.log(process.env);
});

watch(
  () => route.params,
  () => {
    if (hide_footer_on.includes(route.path)) {
      state.showFooter = false;
    } else {
      state.showFooter = true;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SiteHeader, { links: [
      { linkText: 'Interrailkort', linkTo: '/interrailkort' },
      { linkText: 'Guider', linkTo: '/guider' },
      { linkText: 'Support', linkTo: '/support' },
    ] }, {
      left: _withCtx(() => [
        _createVNode(tagluffaieuropa_logo)
      ]),
      "logo-mobile": _withCtx(() => [
        _createVNode(tagluffaieuropa_logo)
      ]),
      _: 1
    }),
    _createVNode(_component_router_view),
    (state.showFooter)
      ? (_openBlock(), _createBlock(SiteFooter, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(CookieModal, {
      show: state.showCookieModal,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (state.showCookieModal = false))
    }, null, 8, ["show"])
  ], 64))
}
}

})